import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Navbar";
import { services } from "../data/services";

const Social = ({ href, label, children }) => (
  <a href={href} aria-label={label} target="_blank" rel="noopener noreferrer">{children}</a>
);

export default function Footer() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  const subscribe = (e) => {
    e.preventDefault();
    if (!email) return;
    window.location.href = `mailto:future@victrie.com?subject=${encodeURIComponent("Subscribe me to Victrie Insights")}&body=${encodeURIComponent(`Please add ${email} to the Victrie newsletter.`)}`;
    setDone(true);
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__top">
          <div>
            <Logo />
            <p style={{ marginTop: 18, maxWidth: 380 }}>
              Victrie is a futuristic software development company in Nairobi, Kenya. We engineer next-generation AI, web, mobile and cloud solutions for ambitious businesses worldwide.
            </p>
            <div className="socials">
              <Social href="https://www.linkedin.com/company/victrie" label="LinkedIn">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M20.4 20.5h-3.6v-5.6c0-1.3 0-3-1.8-3s-2.1 1.4-2.1 2.9v5.7H9.3V9h3.4v1.6c.5-.9 1.7-1.8 3.4-1.8 3.6 0 4.3 2.4 4.3 5.5v6.2zM5.3 7.4a2.1 2.1 0 1 1 0-4.2 2.1 2.1 0 0 1 0 4.2zM7.1 20.5H3.5V9h3.6v11.5z" /></svg>
              </Social>
              <Social href="https://x.com/victrie" label="X (Twitter)">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.5 3h3.1l-6.8 7.8L21.8 21h-6.3l-4.9-6.4L5 21H1.9l7.3-8.3L1.5 3H8l4.4 5.9L17.5 3zm-1.1 16.2h1.7L7 4.7H5.2l11.2 14.5z" /></svg>
              </Social>
              <Social href="https://github.com/victrie" label="GitHub">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a10 10 0 0 0-3.2 19.5c.5.1.7-.2.7-.5v-1.7c-2.8.6-3.4-1.3-3.4-1.3-.4-1.2-1.1-1.5-1.1-1.5-.9-.6.1-.6.1-.6 1 .1 1.5 1 1.5 1 .9 1.6 2.4 1.1 3 .9.1-.7.4-1.1.6-1.4-2.2-.2-4.6-1.1-4.6-4.9 0-1.1.4-2 1-2.7-.1-.3-.4-1.3.1-2.7 0 0 .8-.3 2.7 1a9.4 9.4 0 0 1 5 0c1.9-1.3 2.7-1 2.7-1 .5 1.4.2 2.4.1 2.7.6.7 1 1.6 1 2.7 0 3.8-2.3 4.7-4.6 4.9.4.3.7.9.7 1.9v2.8c0 .3.2.6.7.5A10 10 0 0 0 12 2z" /></svg>
              </Social>
              <Social href="https://www.instagram.com/victrie" label="Instagram">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.5" cy="6.5" r="1" fill="currentColor" /></svg>
              </Social>
            </div>
          </div>
          <div>
            <h4>Services</h4>
            <ul>
              {services.slice(0, 6).map((s) => (
                <li key={s.slug}><Link to={`/services#${s.slug}`}>{s.title.replace(" Solutions", "").replace(" Development", "")}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <h4>Company</h4>
            <ul>
              <li><Link to="/about">About Victrie</Link></li>
              <li><Link to="/solutions">Upcoming Solutions</Link></li>
              <li><Link to="/insights">Insights & Blog</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms of Service</Link></li>
            </ul>
          </div>
          <div>
            <h4>Get in touch</h4>
            <ul>
              <li><a href="mailto:future@victrie.com">future@victrie.com</a></li>
              <li><a href="tel:+254713199322">+254 713 199 322</a></li>
              <li><span style={{ color: "var(--text-2)" }}>Nairobi, Kenya</span></li>
            </ul>
            <h4 style={{ marginTop: 28 }}>Newsletter</h4>
            {done ? (
              <p style={{ color: "var(--lime)" }}>Thanks! Check your email client to confirm.</p>
            ) : (
              <form className="footer__news" onSubmit={subscribe}>
                <input type="email" required placeholder="you@company.com" value={email} onChange={(e) => setEmail(e.target.value)} aria-label="Email address" />
                <button className="btn btn--primary" type="submit" style={{ padding: "12px 18px" }}>Join</button>
              </form>
            )}
          </div>
        </div>
        <div className="footer__bottom">
          <span>© {new Date().getFullYear()} Victrie. All rights reserved. Engineered in Nairobi, Kenya.</span>
          <span>
            <Link to="/privacy">Privacy</Link> · <Link to="/terms">Terms</Link> · <a href="/sitemap.xml">Sitemap</a>
          </span>
        </div>
      </div>
    </footer>
  );
}
